// extracted by mini-css-extract-plugin
module.exports = {"img":"Logo-img-2aWU4"};